import React from 'react';

const CurrentPosition = () => {

	return (
		<div id="About" className='w-4/12 relative space-y-12 flex flex-col'>


			<div>

				<h2 className='text-5xl w-[700px]'>I´m a Front_End Developer.|</h2>
				<p>Currently, I´m a Front End Developer Student at  <a href={"https://www.gammatech.school/"} rel="noreferrer" target='_blank' className='text-sky-500'>Gamma Tech School.</a></p>
			</div>

			<div>
				<p>A methodical accountant with an experience of 4 years, that has decided to make a huge bet to change his career. Since i was young, i have dealt with computers and have felt an increasing interest in the sector of Technology.</p>
			</div>
		</div>
	)
}

export default CurrentPosition;
